/**
 * @file sourceFlag 渠道值工具函数
 * @description 统一处理 sourceFlag 的读取、格式转换和 URL 拼接
 */

/** 从 sessionStorage 读取 sourceFlag（竖线格式，如 11|22|33） */
export function getSourceFlag(): string {
  return sessionStorage.getItem('sourceFlag') || ''
}

/** 将 sourceFlag 转为 URL query 格式（竖线 → 下划线） */
export function sourceFlagToQuery(sourceFlag: string): string {
  return sourceFlag.replace(/\|/g, '_')
}

/** 将 URL query 中的 sourceFlag 转为存储格式（下划线 → 竖线） */
export function sourceFlagFromQuery(queryValue: string): string {
  return queryValue.replace(/_/g, '|')
}

/**
 * 向 URL 拼接 sourceFlag query 参数
 * - 若 URL 已有 sourceFlag 参数则跳过（以 URL 已有值为准）
 * - 若 sessionStorage 无 sourceFlag 则跳过
 */
export function appendSourceFlagToUrl(url: string): string {
  const sourceFlag = getSourceFlag()
  if (!sourceFlag) return url
  // 已有 sourceFlag 参数则不重复拼接
  if (/[?&]sourceFlag=/.test(url)) return url
  const separator = url.includes('?') ? '&' : '?'
  return `${url}${separator}sourceFlag=${sourceFlagToQuery(sourceFlag)}`
}
